import {LicenseInfo} from '@mui/x-data-grid-pro';

LicenseInfo.setLicenseKey(
   '559d318afdc0974baa87c294acc356a2Tz0xMjgxMDEsRT0xODA3NDg3OTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMS0yMDI2LFE9MixLVj0y'
);
